<template>
    <div 
        class="filtered-posts-list" 
        v-observe-visibility="visibilityChanged" 
        :class="['type-'+postType,baseAnimation, { 'has-search' : search}]">
        <CategoriesFilter 
            class="animate-delay-02"
            v-observe-visibility="visibilityChanged" 
            :class="[ baseAnimation ]"
            :key="taxonomy" 
            v-if="filters" 
            :taxonomy="taxonomy" 
            :multiple="filtersMultiple" 
            @filters="updateFilters">
        </CategoriesFilter>
            <div class="main-content">
                <transition-group 
                    name="company" 
                    tag="section"
                    v-if="elementsToShow && elementsToShow.length" 
                    :class="'taxonomy-'+taxonomy+ ' type-'+postType"
                    class="article-list archive-list padding_large animate-delay-03 filters-results posts-wrapper">
                        <component 
                            :is="componentModule" 
                            v-for="(article, i) in elementsToShow" :key="article.id"
                            v-if="i < perPage"
                            :id="article.id"
                        />
                </transition-group >
                <section 
                    v-else-if="!isPageLoaded"
                    v-observe-visibility="visibilityChanged" 
                    :class="[ baseAnimation ]"
                    class="article-list archive-list padding_large posts-wrapper">
                </section>
                <section v-else 
                    class="article-list archive-not-found padding_large posts-wrapper">
                </section>
                <button 
                    v-observe-visibility="visibilityChangedLoadMore" 
                    @click="loadMore" 
                    v-show="(elementsToShow.length > perPage)" 
                    class="btn load-more" 
                    :class="'load-'+postType">
                    <span class="text">Last inn flere {{loadMoreText}}</span>
                </button>
            </div>

    </div>
</template>

<script>
import CategoriesFilter from '@/components/blocks/CategoriesFilter'
import SingleEvent from '@/components/blocks/SingleEvent'
import SinglePost from '@/components/blocks/SinglePost'
import SingleService from '@/components/blocks/SingleService'
import SingleProject from '@/components/blocks/SingleProject'
import SingleMachine from '@/components/blocks/SingleMachine'

import { mapGetters } from 'vuex'

export default {
    name: 'filtered-posts-list',
    props: {
        taxonomy: {
            type: String,
            default: 'category'
        },
        searchPage: {
            type: Boolean,
            default: false
        },
        postType: {
            type: String,
            default: 'post'
        },
        filtersMultiple: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Boolean,
            default: false
        },
        'searchPlaceholder':{
            type: String,
            default: ''
        },
        search: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeFilters: [],
            perPageBase: 6,
            perPage: 6,
            perLoad: 6,
            searchString: '',
        }
    },
    watch:{
        elementsToShow(){
            //this.nullLoadMore()   
        },
        '$route': {
            deep: true,
            handler(to) {
                //this.searchChange( (to.query.search)? to.query.search : '' ) ;
            }
        }
    },
    computed:{
        ...mapGetters([
            'getPosts',
            'getProjects',
            'getServices',
            'getMachines',
            'isPageLoaded',
            'getPostsData',
            'currentPostType'
        ]),
        postsToDisplay(){
            let posts =  null;
            let type = this.postType.toLowerCase()

            if(type === 'posttypes'){
                const postData = this.getPostsData
                posts = []
                Object.keys(postData).forEach(function (item) {
                    if(item !== 'attachment') posts.push(...postData[item]);
                });
            }else{
                if(this.postType == 'post'){
                    posts = this.getPosts(null, this.postType);
                }else if(this.postType == ('projects')){
                    posts = this.getPosts(null, this.postType);
                }else if(this.postType == ('services')){
                    posts = this.getPosts(null, this.postType);
                }else if(this.postType == ('machines')){
                    posts = this.getPosts(null, this.postType);
                }
            }
            return posts;
        },
        loadMoreText(){
            let text = ''
            let type = this.postType.toLowerCase()
            switch (type) {
                case 'projects':
                    text = 'prosjekter'
                    break;
                case 'machines':
                    text = 'maskiner'
                    break;  
                case 'services':
                    text = 'tjenester'
                    break;  
                case 'posttypes':
                    text = ''
                    break;          
                default:
                    text = 'artikler'
                    break;
            }
            return text;
        },
        elementsToShow(){
            const VM = this;
            if(!VM.postsToDisplay) return false;
            let element = VM.postsToDisplay;
            let type = this.postType.toLowerCase()
            let title = '';
            let content = '';
            if(VM.activeFilters.length && VM.filters){
                if(type !== 'posttypes'){
                    element = element.filter( it => {
                        let canShow = false;
                        if(it.acf && it.acf._category && it.acf._category.length) {
                            it.acf._category.forEach(taxID => {
                                if(VM.activeFilters.indexOf(taxID) !== -1){ canShow = true } 
                            })
                        }
                        return canShow;
                    })

                }else{
                    element = element.filter( it => {
                        return (VM.activeFilters.indexOf(it.post_type) !== -1)
                    })
                }

            }
    
            return element;
        },
        componentModule(){
            let component = SinglePost;
            let type = this.postType.toLowerCase()
            switch (type) {
                case 'projects':
                    component = SingleProject;
                    break;
                case 'services':
                    component = SingleService;
                    break;
                case 'machines':
                    component = SingleMachine;
                    break;
                case 'posttypes':
                    component = SinglePost;
                    break;
            }
            return component;
        },
    },
    components:{
        CategoriesFilter,
        SingleEvent,
        SinglePost,
        SingleService,
        SingleProject,
        SingleMachine
    },
    methods: {
        searchChange(val){
            this.searchString = val;
            this.updateRoute()
        },
        updateRoute(){
//            this.$router.replace({ query: { ...this.$route.query, search: this.searchString} })
            setTimeout( ()=>{
                this.$router.push({ query: { kategori: this.activeFilters} })
            }, 50)
        },
        visibilityChangedLoadMore(isVisivle){
            if(isVisivle) this.loadMore();
        },
        loadMore(){
            if(this.elementsToShow.length > this.perPage) this.perPage += this.perLoad;
        },
        nullLoadMore(){
            this.perPage =this.perPageBase;
        },
        updateFilters(filters){
            this.activeFilters = filters;
            this.updateRoute()
        },
    },
};
</script>


<style lang="scss">
</style>